module.exports = __webpack_public_path__ + "img/IMG_0231.f7aebdad.jpg";